import {SocialFooter} from "../components/common/CommonLayout";
import React from "react";
import {useAppDispatch} from "../components/common/Global";
import {setPageTitle} from "./common/NavigationState";
import {ContentBox} from "../components/ContentBox";
import {TextPanel} from "../components/TextPanel";
import {Link} from "@mui/material";

export const DiscordPage = () => {
  const dispatch = useAppDispatch();
  dispatch(setPageTitle("Ocarina Discord Community"));

  return (
    <>
      <OcamigosPanel />
      <OcwalkPanel />
      <SocialFooter />
    </>
  );
};

const OcamigosPanel = () => (
  <ContentBox image="ocarinas">
    <TextPanel
      flavor="Ocarina community discord"
      title="Ocamigos"
      description={
        <>
          David Erick Ramos runs a huge ocarina related Discord server called Ocamigos. <br />
          If you are looking for a warm and cozy place to hangout - check it out! <br />
          Also subscribe to David's YouTube channel, if you haven't already :)
        </>
      }
      align="right"
      primaryButtonTitle="Join Ocamigos"
      primaryButtonUrl="https://discord.com/invite/U4VYJfe"
      secondaryButtonTitle="David Erick Ramos"
      secondaryButtonUrl="https://www.youtube.com/@DavidErickRamos"
    />
  </ContentBox>
);

const OcwalkPanel = () => (
  <ContentBox image="ocarinas">
    <TextPanel
      flavor="A tiny place"
      title="OCWALK Discord"
      description={
        <>
          If you have questions about OCWALK - you can reach out through our discord. <br />
          We don't run an ocarina community. This server is focused on OCWALK project. <br />
          Share pictures of your ocarinas, if you decide to join!
        </>
      }
      align="left"
      primaryButtonTitle="Join OCWALK"
      primaryButtonUrl="https://discord.com/invite/QX7C3YsSnF"
    />
  </ContentBox>
);
